export const resourcesModule = {
    slug: 'resources',
    label: 'Resources',
    description: 'Query templates and data resources dispatched to agents.',
    icon: 'Database',
};
//# sourceMappingURL=resources.js.map